import { create } from "zustand";
import { State } from "@/models";

export const useApiStore = create<State.API>((set) => ({
  setAllState: (newState: State.API) => {
    set(() => ({ ...newState }));
  },
  setState: (key: keyof State.API, value: any) => {
    set((state: State.API) => ({
      ...state,
      [key]: value,
    }));
  },
  setPayload: (key: string | string[], value: string) => {
    set((state: State.API) => {
      const keys = Array.isArray(key) ? key : [key];

      const newPayload = {
        ...state.payload,
      };

      keys.forEach((k) => {
        newPayload[k] = value;
      });

      return {
        ...state,
        payload: newPayload,
      };
    });
  },

  fields: [],
  setFields: (name: string | string[], value: string) => {
    set((state: State.API) => {
      const names = Array.isArray(name) ? name : [name];
      const newState = {
        ...state,
        payload: {
          ...state.payload,
        },
        fields: state.fields.map((item) => {
          if (names.includes(item.name)) {
            return { ...item, value };
          } else {
            return item;
          }
        }),
      };

      names.forEach((n) => {
        newState.payload[n] = value;
      });

      return newState;
    });
  },

  set: (
    payload: any,
    endpoint: string,
    method?: "POST" | "PUT" | "DELETE" | "GET",
    callBackFunction?: () => void
  ) => {
    set((state: State.API) => ({
      ...state,
      method,
      payload: {
        ...state.payload,
        ...payload,
      },
      endpoint,
      callBackFunction,
    }));
  },
  setIsProcessing: (isProcessing?: boolean) => {
    set((state: State.API) => ({
      ...state,
      isProcessing,
    }));
  },
}));
